
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"192","height":"192","viewBox":"0 0 192 192"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"stroke":"#333","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"8","d":"M164 62l-68 68-68-68"}}),_c('path',{attrs:{"d":"M0 0h192v192H0z"}})])])
          )
        }
      }
    